var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:_vm.type},[(_vm.isImage && _vm.hasMedia)?_c('img',{attrs:{"src":_vm.url}}):(!_vm.isImage && _vm.hasMedia)?_c('video',{attrs:{"src":_vm.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }